import React from 'react'
import util from '../util/util.js'
import cx from 'classnames'
import ChatBox from './Chat.jsx'
import Error from './Error.jsx'
import Success from './Success.jsx'
import Share from './Share.jsx'
import UpcomingBroadcasts from './UpcomingBroadcasts.jsx'

function subscribeSubmit(ssId, name, emailAddress, firstName, lastName, cb) {
  if (_.isEmpty(emailAddress) || _.isEmpty(firstName) || _.isEmpty(lastName)) {
    return cb('Please fill out all fields', null)
  }

  if (!util.validateEmail(emailAddress)) {
    return cb('Please provide a valid email address', null)
  }

  var request = new XMLHttpRequest()
  request.open('GET', '/email/subscribe?ssId=' + ssId + '&venue=' + name + '&email=' + emailAddress + '&firstName=' + firstName + '&lastName=' + lastName, true)
  request.onload = function() {
    if (request.status >= 200 && request.status < 400) {
      // Success!
      var data = JSON.parse(request.responseText)
      if (!data.error) {
        cb(null, 'You have successfully subscribed to weekly schedule emails for this broadcaster.')
      } else {
        cb('Sorry, ' + data.errorText, null)
      }
    } else {
      cb('Sorry, it seems that an internal problem has occurred. Please try again later.', null)
    }
  }

  request.onerror = function() {
    cb('Sorry, there is a problem connecting to the server. Please try again later.', null)
  }
  request.send()
}

var Donate = React.createClass({
  extractscript: null,
  componentDidMount: function() {
    $('.donate-section .donate-wrapper').html($('<textarea/>').html(this.props.player.broadcaster.donate).text())
  },
  render: function() {
    return (
      <div className="donate-section">
        <h2 className="header"><i className="fa fa-money"></i> Donate</h2>
        <div className="donate-wrapper"></div>
      </div>
    )
  }
})


var BroadcasterName = React.createClass({
  render: function() {
    return (<span className="church-name">{this.props.player.broadcaster.name}</span>)
  }
})

var SubscribeToBroadcasts = React.createClass({
  getInitialState: function() {
    return {
      firstName : '',
      lastName: '',
      email: '',
      errorMessage: null,
      successMessage: null
    }
  },
  render: function() {
    return (
      <div>
        <h2 className="header"><i className="fa fa-calendar"></i> Subscribe to Broadcast Schedule</h2>
        <p>After signing up, you will receive the broadcast schedule for <BroadcasterName player={this.props.player}/> every Friday.</p>
        <Error message={this.state.errorMessage}/>
        <Success message={this.state.successMessage}/>
        <form>
          <div className="form-group">
            <label>First Name</label>
            <input className="form-control" type="text" ref="firstName" defaultValue={this.state.firstName} />
          </div>
          <div className="form-group">
            <label>Last Name</label>
            <input className="form-control" type="text" ref="lastName" defaultValue={this.state.lastName} />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input className="form-control" type="email" ref="email" defaultValue={this.state.email} />
          </div>
          <button onClick={this.submit} type="submit" className="btn btn-streamspot">Submit</button>
        </form>
      </div>
    )
  },

  submit: function(e) {
    e.preventDefault()
    // Get values via this.refs
    var firstName = this.refs.firstName.value
    var lastName= this.refs.firstName.value
    var email   = this.refs.email.value
    this.setState({email, firstName, lastName})
    subscribeSubmit(this.props.player.broadcaster.ssId, this.props.player.broadcaster.name, email, firstName, lastName, function(err, success){
      if(err){
        this.setState({errorMessage: err, successMessage: null})
      } else{
        this.setState({successMessage: success, errorMessage: null})
      }
    }.bind(this))
    return false
  }
})


var MenuView = React.createClass({
  propTypes: {
    view: React.PropTypes.string.isRequired
  },
  render: function() {
    switch (this.props.view) {
    case 'upcoming-broadcasts':
      return (<UpcomingBroadcasts player={this.props.player} broadcasts= {this.props.player.broadcasts}/>)
    case 'subscribe-to-broadcasts':
      return (<SubscribeToBroadcasts player={this.props.player}/>)
    case 'donate':
      return (<Donate player={this.props.player} />)
    case 'share':
      return (<Share player={this.props.player}/>)
    case 'chat':
      return (
        <section>
          <h2 className="header"><i className="fa fa-comments"></i> Chat</h2>
          <ChatBox/>
        </section>
      )
    case 'none':
      return false
    }
  }
})

var MenuButtons = React.createClass({
  handleClick: function(event){
    this.props.onViewChange(event.currentTarget.attributes.name.value)
  },
  render: function() {
    var Player = this.props.player
    var showUpcomingBroadcasts = this.props.showSchedule
    var showDonate = Player.broadcaster.isDonate
    var showChat = Player.broadcaster.is_chat && Player.broadcaster.isBroadcasting && this.props.live
    var showSubscribe = this.props.showSubscribe
    var buttons = []
    let shareButtonClass = cx({
      btn: true,
      'btn-default': true,
      active: this.props.view === 'share'
    })
    //BCD work around to resolve broken schedule on single archive page
    if( showUpcomingBroadcasts ){
      //console.log('state: ' + this.props.player.state)
      if( this.props.player.state == "single" ){
        showUpcomingBroadcasts = false
      }
    }

    buttons.push(<div key='share' className="btn-group" role="group"><button onClick={this.handleClick} name='share' type="button" className={shareButtonClass}><i className="fa fa-share-alt"></i> Share</button></div>)
    if(showUpcomingBroadcasts){
      let upcomingBroadcastsButtonClass = cx({
        btn: true,
        'btn-default': true,
        active: this.props.view === 'upcoming-broadcasts'
      })
      buttons.push(<div key='upcoming-broadcasts' className="btn-group" role="group"><button onClick={this.handleClick} name='upcoming-broadcasts' type="button" className={upcomingBroadcastsButtonClass}><i className="fa fa-calendar"></i> Schedule</button></div>)
    }
    if(showSubscribe){
      let subscribeButtonClass = cx({
        btn: true,
        'btn-default': true,
        active: this.props.view === 'subscribe-to-broadcasts'
      })
      buttons.push(<div key='subscribe-to-broadcasts' className="btn-group" role="group"><button onClick={this.handleClick} key='subscribe-to-broadcasts' name='subscribe-to-broadcasts' type="button" className={subscribeButtonClass}><i className="fa fa-rss"></i> Subscribe</button></div>)
    }
    if(showChat){
      let chatButtonClass = cx({
        btn: true,
        'btn-default': true,
        active: this.props.view === 'chat'
      })
      buttons.push(<div key='chat' className="btn-group" role="group"><button onClick={this.handleClick} name='chat' type="button" className={chatButtonClass}><i className="fa fa-comments"></i> Chat</button></div>)
    }
    if(showDonate){
      let donateButtonClass = cx({
        btn: true,
        'btn-default': true,
        active: this.props.view === 'donate'
      })
      buttons.push(<div key='donate' className="btn-group" role="group"><button onClick={this.handleClick}  name='donate' type="button" className={donateButtonClass}><i className="fa fa-money"></i> Donate</button></div>)
    }
    if(buttons.length === 1) return false
    return(
      <div className="btn-group btn-group-justified" role="group" aria-label="...">
        {buttons}
      </div>
    )
  }
})

var Menu = React.createClass({
  getInitialState: function() {
    var live = false
    if(this.props.player && this.props.player.broadcaster.isBroadcasting){
      live = true
    }
    return {
      view : 'share',
      live: live,
      listener: null
    }
  },
  componentDidMount: function() {
    this.setState({
      listener: this.props.player.emitter.addListener('play', this.changeLive)
    })
  },
  componentWillUnmount: function() {
    this.state.listener.remove()
  },
  changeLive: function(video){
    //make sure it's defined
    if( typeof video == 'undefined' ){
      this.setState({
        live: false,
        view: 'share'
      })
    } else {
      if(video.live){
        this.setState({
          live: (video.live)
        })
      }else{
        this.setState({
          live: false,
          view: 'share'
        })
      }
    }
  },
  onViewChange: function(view) {
    this.setState({view: view})
  },
  render: function() {
    return(
      <div>
        <div className="col-md-12">
          <div id="ss-action-buttons">
            <MenuButtons player={this.props.player} showSchedule={this.props.showSchedule} showSubscribe={this.props.showSubscribe} live={this.state.live} view={this.state.view} onViewChange={this.onViewChange}/>
          </div>
        </div>
        <div className="col-md-12" id="ss-menu-view">
          <MenuView player={this.props.player} view={this.state.view}/>
        </div>
        <hr className='hr'></hr>
      </div>
    )
  }
})

module.exports = Menu



// WEBPACK FOOTER //
// ./src/components/Menu.jsx